import {NotificationService} from '../services';
import {EnvService} from '../services';

import gql from 'graphql-tag';
import client from '../services/ApolloService';
/**
 * Action Types
 */
export const UPDATE_STATE = 'auto-captura/Graphql/UPDATE_STATE';

export const GET_FRONT_VALIDATIONACCESSCODE =
  'auto-captura/Graphql/GET_FRONT_VALIDATION_ACCESS_CODE';
export const GET_FRONT_VALIDATIONACCESSCODE_SUCCESS =
  'auto-captura/Graphql/GET_FRONT_VALIDATIONACCESSCODE_SUCCESS';
export const GET_FRONT_VALIDATIONACCESSCODE_FAIL =
  'auto-captura/Graphql/GET_FRONT_VALIDATIONACCESSCODE_FAIL';
/**
 * Reducer
 */
const initialState = {
  loading: false,
  fontePrimaria: '',
  fonteSecundaria: '',
  backgroundPrimario: '',
  backgroundSecundario: '',
  logo: {
    url_image: '',
    alt_image: '',
  },
  banner: {
    url_image: '',
    alt_image: '',
  },
  bannerSeguros: {
    url_image: '',
    alt_image: '',
  },
  bannerSegurosMobile: {
    url_image: '',
    alt_image: '',
  },
  acesso: {
    url_image: '',
    alt_image: '',
  },
  beneficioTitulo: '',
  beneficios: [
    {
      id: '',
      url_image: '',
      alt_image: '',
      feature: '',
      description: '',
    },
  ],
  rodape: {
    url_image: '',
    alt_image: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STATE:
      return {
        ...state,
        payload: action.payload,
      };

    case GET_FRONT_VALIDATIONACCESSCODE_SUCCESS:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default reducer;
/**
 * Action Creators
 */

const showErrors = (e, service) => {
  if (EnvService.get('ENV') === 'dev') {
    NotificationService.showValidationSingleError(e.Error);
    console.log(`Requisição ${service} com erro :`, e);
  } else
    NotificationService.showValidationSingleError(
      `Não foi possível ${service}. Por favor, tente novamente mais tarde.`,
    );
};

export const buscarFrontValidationAccessCode = (rede) => async (dispatch) => {
  dispatch({type: GET_FRONT_VALIDATIONACCESSCODE});
  const itemsHtml = initialState;

  try {
    let result = await client.query({
      query: GraphqlQuery,
      variables: {
        path: rede,
      },
    });

    if (result.data.content.length > 0) {
      const {
        brand,
        secondaryBanner,
        secondaryBannerLink,
        footerImage,
        footerImageLink,
        insuranceBanner,
        insuranceBannerMobile,
      } = result.data.content[0];

      itemsHtml.loading = true;

      //BANNER PRINCIPAL
      itemsHtml.banner.url_image = secondaryBanner.urls[0];
      itemsHtml.banner.alt_image = secondaryBannerLink.text;

      //RODAPE

      itemsHtml.rodape.url_image = footerImage.urls[0];
      itemsHtml.rodape.alt_image = footerImageLink.text;

      //BANNER DE SEGUROS
      itemsHtml.bannerSeguros.url_image = insuranceBanner
        ? insuranceBanner.urls[0]
        : '';
      itemsHtml.bannerSeguros.alt_image = insuranceBanner
        ? insuranceBanner.paths[0]
        : '';

      itemsHtml.bannerSegurosMobile.url_image = insuranceBannerMobile
        ? insuranceBannerMobile.urls[0]
        : '';
      itemsHtml.bannerSegurosMobile.alt_image = insuranceBannerMobile
        ? insuranceBannerMobile.paths[0]
        : '';

      if (brand) {
        if (brand.contentItems[0]) {
          //COR DE FUNDO E COR DE FONTE
          const {
            backgroundPrimaryColor,
            backgroundSecondaryColor,
            foregroundPrimaryColor,
            foregroundSecondaryColor,
            card,
            logo,
          } = brand.contentItems[0];

          itemsHtml.backgroundPrimario = backgroundPrimaryColor;
          itemsHtml.backgroundSecundario = backgroundSecondaryColor;
          itemsHtml.fontePrimaria = foregroundPrimaryColor;
          itemsHtml.fonteSecundaria = foregroundSecondaryColor;

          //LOGO
          itemsHtml.logo.url_image = logo.urls[0];
          itemsHtml.logo.alt_image = logo.paths[0];

          itemsHtml.logo.url_image = logo.urls[0];
          itemsHtml.logo.alt_image = logo.paths[0];

          if (card) {
            if (card.contentItems.length > 0) {
              const {mainBanner, benefitsTitle, benefits} =
                card.contentItems[0];
              //ACESSO
              itemsHtml.acesso.url_image = mainBanner.urls[0];
              itemsHtml.acesso.alt_image = mainBanner.paths[0];

              itemsHtml.beneficioTitulo = benefitsTitle;
              itemsHtml.beneficios = benefits.contentItems.map((b) => {
                return {
                  id: b.contentItemId,
                  url_image: b.icon.urls[0],
                  alt_image: b.feature,
                  feature: b.feature,
                  description: b.description,
                };
              });
            } else {
              itemsHtml.beneficios = [];
            }
          }
        }
      }
      dispatch({
        type: UPDATE_STATE,
        payload: itemsHtml,
      });
    }

    dispatch({type: GET_FRONT_VALIDATIONACCESSCODE_SUCCESS});
    return itemsHtml;
  } catch (e) {
    showErrors(e, ' carregar tela inicial');
    dispatch({type: GET_FRONT_VALIDATIONACCESSCODE_FAIL});
  }
};

const GraphqlQuery = gql`
  query ($status: Status = PUBLISHED, $path: String!) {
    content: autocaptureContent(status: $status, where: {path: $path}) {
      path
      secondaryBanner {
        paths
        urls
      }
      secondaryBannerLink {
        url
        text
        openInNewTab
      }
      footerImage {
        paths
        urls
      }
      insuranceBanner {
        paths
        urls
      }
      insuranceBannerMobile {
        paths
        urls
      }
      footerImageLink {
        url
        text
        openInNewTab
      }
      brand {
        contentItems {
          ... on Brand {
            logo {
              paths
              urls
            }
            backgroundPrimaryColor
            foregroundPrimaryColor
            backgroundSecondaryColor
            foregroundSecondaryColor
            card {
              contentItems {
                ... on Cartao {
                  mainBanner: bannerPrincipal {
                    paths
                    urls
                  }
                  mainBannerMobile: bannerPrincipalMobile {
                    paths
                    urls
                  }

                  highLightBenefits: caracteristicasDestaque {
                    contentItems(first: 4) {
                      ... on CartaoCaracteristica {
                        contentItemId
                        icon: icone {
                          paths
                          urls
                        }
                        description: descricao
                        feature: caracteristica
                      }
                    }
                  }
                  benefitsTitle: tituloCaracteristicas
                  benefits: caracteristicas {
                    contentItems(first: 4) {
                      ... on CartaoCaracteristica {
                        contentItemId
                        icon: icone {
                          paths
                          urls
                        }
                        description: descricao
                        feature: caracteristica
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
